import { gql, useMutation } from '@apollo/client';

export const CHANGE_CONTINUE_WORKING_STATUS = gql`
  mutation changeContinueWorkingStatus($payload: ChangeContinueWorkingInput!) {
    changeContinueWorkingStatus(payload: $payload) {
      _id
    }
  }
`;

export const useChangeContinueWorkingStatus = () => {
  const [changeContinueWorkingStatus, { loading }] = useMutation(CHANGE_CONTINUE_WORKING_STATUS);

  return { changeContinueWorkingStatus, loading };
};
